import React, { useState } from "react";
import Header from "../../Components/Header";
import SellerHeader from "../../Components/SellerHeader";
import SellerSidebar from "../../Components/SellerSidebar";
import { WithContext as ReactTags } from "react-tag-input";

import Select from "react-select";
import {
  detail,
  sketch,
  svg1,
  svg2,
  svg3,
  svg4,
  svg5,
  upperarrow,
} from "../../Constant/Index";
import Footer from "../../Components/Footer";
import AccessControl from "../../Components/Auth/AccessControl";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ReUse from "../../services/helpers/reUse";
import AppService from "../../services/appServices";
import { toast } from "react-toastify";
import {
  clearResponseMessageAfterDelay,
  errorMessage,
  successMessage,
} from "../../redux/slices/responseMessage.slice";
import { SellerAddProduct } from "../../Hooks/productInventory/SellerAddProduct";
import { useEffect } from "react";
import CustomButton from "../../Components/ReUse/Components/Button";
import ResponseMessage from "../../Components/ReUse/ResponseMessage";
import FieldError from "../../Components/ReUse/FieldError";
import RenderImage from "../../Components/ReUse/RenderImage";
import RenderUploadedImage from "../../pages/Seller-Profile/RenderUploadedImage";
import IndividualVariant from "../../pages/Seller-Profile/IndividualVariant";
import BulkVariant from "../../pages/Seller-Profile/BulkVariant";

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

function EditProductContent({ data, currentIndex }) {
  const {
    // attributes,
    brand_id,
    brand_name,
    category_id,
    category_name,
    country_id,
    country_name,
    current_stock,
    description,
    discount,
    discount_type,
    images,
    moq_selling,
    product_id,
    product_name,
    purchase_price,
    rating,
    review_count,
    reviews,
    seller_id,
    seller_name,
    slug,
    sub_category_id,
    sub_category_name,
    thumbnail,
    unit_price,
    variations,
    size_chart_url,
  } = data ?? {};

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [fileupload, setFileupload] = useState(thumbnail || {});
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [attributeOptions, setAttributeOptions] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [attributesLoader, setAttributesLoader] = useState(false);

  const [productCategories, setProductCategories] = useState([]);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [selectedProductCategory, setSelectedProductCategory] =
    useState(category_id);
  const [selectedProductSubCategory, setSelectedProductSubCategory] =
    useState(sub_category_id);
  const [categoriesLoader, setCategoriesLoader] = useState(false);
  const [subCategoriesLoader, setSubCategoriesLoader] = useState(false);

  const [choiceAttributes, setchoiceAttributes] = useState([]);
  const [choice, setChoice] = useState([]);
  const [choiceOptions, setChoiceOptions] = useState([]);
  const [choiceNo, setChoiceNo] = useState([]);

  const [allErrors, setAllErrors] = useState({
    name: "",
    category_id: "",
    sub_category_id: "",
    unit_price: "",
    discount: "",
    discount_type: "",
    current_stock: "",
    details: "",
    purchase_price: "",
  });

  const [fieldsData, setFieldsData] = useState({
    name: product_name,
    unit_price: unit_price,
    current_stock: current_stock,
    details: description,
    purchase_price: purchase_price,
  });

  const [selectedAttributes, setSelectedAttributes] = useState(
    variations || []
  );

  const [selectedAttributeValues, setSelectedAttributeValues] = useState([]);

  const [uploadedImages, setUploadedImages] = useState(images || []);

  const [inventoryTypes, setInventoryTypes] = useState([
    {
      value: 1,
      label: "Normal",
    },
    {
      value: 2,
      label: "Bulk",
    },
  ]);

  const [sizeChart, setSizeChart] = useState(size_chart_url || "");

  const [selectedInventoryType, setSelectedInventoryType] = useState(
    moq_selling?.length > 0 ? inventoryTypes[1] : inventoryTypes[0]
  );

  const { value, label } = selectedInventoryType ?? {};

  useEffect(() => {
    const sellerGetAttributes = AppService.sellerGetAttributes();
    ReUse.getApiData(sellerGetAttributes, setAttributes, setAttributesLoader);

    const sellerGetcategories = AppService.sellerGetcategories();
    ReUse.getApiData(
      sellerGetcategories,
      setProductCategories,
      setCategoriesLoader
    );
  }, []);

  useEffect(() => {
    const sellerGetsubCategories = AppService.sellerGetsubCategories({
      categoryId: selectedProductCategory?.value,
    });
    ReUse.getApiData(
      sellerGetsubCategories,
      setProductSubCategories,
      setSubCategoriesLoader
    );
  }, [selectedProductCategory]);

  const extractAttributeOptions = ReUse.minifyArrayOfObjects({
    data: attributes,
  });

  const handleAttributeOptionAddition = ({
    attributeOption,
    attributeIndex,
    attributeType,
  }) => {
    const updatedAttributeOptions = [...attributeOptions];
    const { label, id } = attributeOption ?? {};
    if (updatedAttributeOptions[attributeIndex]) {
      updatedAttributeOptions[attributeIndex].push({
        id: id,
        text: id,
      });
    } else {
      updatedAttributeOptions[attributeIndex] = [
        {
          id: id,
          text: id,
        },
      ];
    }

    setAttributeOptions(updatedAttributeOptions);

    const updatedSelectedAttributeValues = [...selectedAttributeValues];
    if (updatedSelectedAttributeValues[attributeIndex]) {
      updatedSelectedAttributeValues[attributeIndex]?.values?.push(
        attributeOption
      );
    } else {
      updatedSelectedAttributeValues[attributeIndex] = {
        selectedAttribute: attributeType,
        values: [attributeOption],
      };
    }

    setSelectedAttributeValues(updatedSelectedAttributeValues);
  };

  const handleAttributeOptionDrag = (attributeOption, currPos, newPos) => {
    const newAttributeOptions = attributeOptions?.slice();
    newAttributeOptions?.splice(currPos, 1);
    newAttributeOptions?.splice(newPos, 0, attributeOption);
    setAttributeOptions(newAttributeOptions);
  };

  const handleAttributeOptionDelete = ({
    attributeOption,
    attributeIndex,
    attributeType,
  }) => {
    const updatedAttributeOptions = [...attributeOptions];
    const currentAttributeOptions = updatedAttributeOptions[attributeIndex];

    if (currentAttributeOptions) {
      const updatedValues = currentAttributeOptions?.filter(
        (option) => option?.id !== attributeOption?.id
      );

      updatedAttributeOptions[attributeIndex] = updatedValues;

      setAttributeOptions(updatedAttributeOptions);
    }
  };

  const handleAttributeOptionClick = (index) => {};

  function handleChange(e) {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    const { value, name } = e.target;
    setFieldsData({
      ...fieldsData,
      [name]: value,
    });
  }

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const { name, unit_price, current_stock, details, purchase_price } =
        fieldsData ?? {};

      const fields = {
        name,
        unit_price,
        current_stock,
        details,
        purchase_price,
        category_id: selectedProductCategory,
        sub_category_id: selectedProductSubCategory,
        discount: "0",
        discount_type: "amount",
        thumbnail: fileupload,
        sizeChart: sizeChart,
      };
      const allErrors = ReUse.validateRequired({ fields: fields });

      // Check if there are any errors
      if (Object.keys(allErrors).length > 0) {
        setAllErrors(allErrors);
        setLoading(false);
        return;
      }

      if (uploadedImages?.length < 3) {
        setLoading(false);
        dispatch(errorMessage("Please  Upload Atleast 3 images"));
        dispatch(clearResponseMessageAfterDelay());
        return;
      }

      const moqData = bulkVariantData?.map((data, index) => {
        const fieldsData = bulkVariantAddFieldsData[index] || [];

        const moqs =
          fieldsData?.map(({ moq, price }) => ({ moq, price })) || [];

        return {
          qty: data?.qty,
          sku: data?.sku,
          moqs: moqs,
        };
      });

      const payload = {
        name: name,
        category_id: selectedProductCategory,
        sub_category_id: selectedProductSubCategory,
        choice_attributes: choiceAttributes,
        choice: choice,
        choice_no: choiceNo,
        unit_price: parseInt(unit_price),
        current_stock: parseInt(current_stock),
        discount: 0,
        discount_type: "amount",
        unit: "pc",
        details: details,
        purchase_price: parseInt(purchase_price),
        images: uploadedImages,
        thumbnail: file,
      };

      choiceOptions?.forEach((option) => {
        Object.entries(option).forEach(([key, value]) => {
          payload[key] = value;
        });
      });

      if (selectedInventoryType?.value === 1) {
        payload.variations = variantData;
      }

      if (selectedInventoryType?.value === 2) {
        payload.moq_selling = moqData;
      }

      const apiResp = await AppService.sellerAddProduct(payload);

      const { message, response } = apiResp.data;
      setLoading(false);
      dispatch(successMessage(message));
      setTimeout(() => {
        dispatch(successMessage("Navigating..."));
        setTimeout(() => {
          dispatch(successMessage(""));
          navigate("/seller-product-inventory");
        }, 1000);
      }, 1000);

      ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
      ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
    } catch (err) {
      setLoading(false);
      dispatch(errorMessage(err?.response?.data?.message));
      dispatch(clearResponseMessageAfterDelay());
      ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
      ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
      dispatch(successMessage(""));
    }
  };

  const handleThumbnailUpload = (e) => {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    ReUse.handleFileUploads(e).then((result) => {
      const { fileOutput, fileUpload } = result;
      setFile(fileOutput);
      setFileupload(fileUpload);
    });
  };

  const handleMultipleImagesUpload = async (e) => {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    try {
      const newImages = await ReUse.handleMultipleImagesUpload({
        e: e,
        prevImages: uploadedImages,
      });
      setUploadedImages(newImages);
    } catch (error) {}


  };


  const extractAttributeValues = () => {
    try {
      if (!selectedAttributeValues || !Array.isArray(selectedAttributeValues)) {
        return [];
      }

      const attributeValues = selectedAttributeValues.map(
        ({ selectedAttribute, values }) => {
          if (!selectedAttribute || !values || !Array.isArray(values)) {
            return [];
          }

          const labels = values?.map(({ text }) => text);
          return { [selectedAttribute]: labels };
        }
      );

      const mergedAttributes = Object.assign({}, ...attributeValues);
      return mergedAttributes;
    } catch (error) {
      return [];
    }
  };

  const extractCategoriesOptions = ReUse.minifyArrayOfObjects({
    data: productCategories,
  });

  const extractSubCategoriesOptions = ReUse.minifyArrayOfObjects({
    data: productSubCategories,
  });

  const SellerAddProductHook = SellerAddProduct(extractAttributeValues());

  const { generatedVariations, useVariantDataHandler } = SellerAddProductHook;

  const [
    variantData,
    variantDataHandler,
    bulkVariantData,
    bulkVariantDataHandler,
    bulkVariantMOQs,
    variantMOQsHandler,
    bulkVariantAddFieldsData,
  ] = useVariantDataHandler();

  const IndividualVariantProps = {
    variantData,
    variantDataHandler,
    extractAttributeOptions,
    setSelectedAttributes,
    selectedAttributes,
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    handleAttributeOptionClick,
    generatedVariations,
  };

  const BulkVariantProps = {
    bulkVariantData,
    bulkVariantDataHandler,
    bulkVariantMOQs,
    variantMOQsHandler,
    extractAttributeOptions,
    setSelectedAttributes,
    selectedAttributes,
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    handleAttributeOptionClick,
    generatedVariations,
    bulkVariantAddFieldsData,
  };

  const SelectedInventoryType = () => {
    if (value === 1) {
      return (
        <>
          <IndividualVariant inventoryVariantProps={IndividualVariantProps} />
        </>
      );
    } else if (value === 2) {
      return (
        <>
          <BulkVariant inventoryVariantProps={BulkVariantProps} />
        </>
      );
    } else {
      return null;
    }
  };

  const UploadedImages = () => {
    if (uploadedImages?.length > 0) {
      return (
        <>
          <div className="uploaded-images-wrapper">
            {uploadedImages?.map((image) => (
              <RenderUploadedImage imageURL={image} />
            ))}
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  useEffect(() => {
    if (selectedAttributes) {
      const ids = selectedAttributes?.map(({ value }) => value);
      const labels = selectedAttributes?.map(({ label }) => label);

      setchoiceAttributes(ids);
      setChoiceNo(ids);
      setChoice(labels);
    }
  }, [selectedAttributes]);

  useEffect(() => {
    if (selectedAttributeValues) {
      const choiceOptions = choiceAttributes?.map((choiceAttribute, index) => ({
        [`choice_options_${choiceAttribute}`]:
          selectedAttributeValues[index]?.values?.map(({ text }) => text) || [],
      }));

      setChoiceOptions(choiceOptions);
    }
  }, [selectedAttributeValues]);

  const handleSizeChartUpload = (e) => {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    ReUse.handleFileUploads(e).then((result) => {
      const { fileOutput, fileUpload } = result;
      setSizeChart(fileOutput);
      setSizeChart(fileUpload);
    });
  };

  return (
    <>
      <AccessControl allowedRoles={["seller"]}>
        <SellerHeader />
        {/* Seller Adding Product starts here */}
        <section className="seller-dashboard">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 ps-0">
                <SellerSidebar />
              </div>
              <div className="col-lg-8">
                <div className="edit-profile-card edit-no-padding-right adding-main-product-scroll">
                  <div className="edit-heading-wrapper">
                    <h2>Updating product</h2>
                  </div>

                  <div className="seller-edit-with-border-dv">
                    <div className="row">
                      <div className="col-md-10">
                        <div className="edit-">
                          <div className="seller-all-form">
                            <form>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="seller-edit-form-dropdown">
                                    <Select
                                      isMulti={false}
                                      name="categories"
                                      options={extractCategoriesOptions}
                                      classNamePrefix="select"
                                      value={extractCategoriesOptions?.find(
                                        (option) =>
                                          option?.value ===
                                          selectedProductCategory
                                      )}
                                      onChange={(option) => {
                                        setSelectedProductCategory(
                                          option?.value
                                        );
                                        const resetErrors = ReUse.resetErrors({
                                          fields: allErrors,
                                        });
                                        setAllErrors(resetErrors);
                                      }}
                                      defaultValue={selectedProductCategory}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.category_id}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="seller-edit-form-dropdown">
                                    <Select
                                      isMulti={false}
                                      name="categories"
                                      options={extractSubCategoriesOptions}
                                      value={extractSubCategoriesOptions?.find(
                                        (option) =>
                                          option?.value ===
                                          selectedProductSubCategory
                                      )}
                                      // class="form-select"
                                      classNamePrefix="select"
                                      onChange={(option) => {
                                        setSelectedProductSubCategory(
                                          option?.value
                                        );
                                        const resetErrors = ReUse.resetErrors({
                                          fields: allErrors,
                                        });
                                        setAllErrors(resetErrors);
                                      }}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.sub_category_id}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Product Name"
                                      onChange={handleChange}
                                      name="name"
                                      value={fieldsData?.name}
                                    />
                                    <FieldError fieldName={allErrors?.name} />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Stock Quantity"
                                      onChange={handleChange}
                                      name="current_stock"
                                      value={fieldsData?.current_stock}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.current_stock}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Unit Price"
                                      onChange={handleChange}
                                      name="unit_price"
                                      value={fieldsData?.unit_price}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.unit_price}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Purchase Price"
                                      onChange={handleChange}
                                      name="purchase_price"
                                      value={fieldsData?.purchase_price}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.purchase_price}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <div className="seller-edit-form-input">
                                    <textarea
                                      class="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      placeholder="Description"
                                      name="details"
                                      value={ReUse.removeHTMLTags({
                                        unStripped: fieldsData?.details,
                                      })}
                                      onChange={handleChange}
                                    ></textarea>
                                    <FieldError
                                      fieldName={allErrors?.details}
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>

                            <div className="row">
                              <div className="col-md-12">
                                <div className="label-and-upload-product-btn">
                                  <label>Select Product Images</label>
                                  <div className="upload-btn">
                                    <button>
                                      <span>
                                        <img
                                          className="img-fluid"
                                          alt="upper-arrow"
                                          src={upperarrow}
                                        />{" "}
                                        Upload Pictures
                                      </span>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        multiple
                                        onChange={handleMultipleImagesUpload}
                                      />
                                    </button>
                                  </div>

                                  <div className="upload-btn">
                                    <button>
                                      <span>
                                        <img
                                          className="img-fluid"
                                          alt="upper-arrow"
                                          src={upperarrow}
                                        />{" "}
                                        Upload Thumbnail
                                      </span>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        multiple={false}
                                        onChange={handleThumbnailUpload}
                                      />
                                    </button>
                                    <FieldError
                                      fieldName={allErrors?.thumbnail}
                                    />
                                  </div>

                                  <div className="upload-btn">
                                    <button>
                                      <span>
                                        <img
                                          className="img-fluid"
                                          alt="upper-arrow"
                                          src={upperarrow}
                                        />{" "}
                                        Upload Size Chart
                                      </span>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        multiple={false}
                                        onChange={handleSizeChartUpload}
                                      />
                                    </button>
                                    <FieldError
                                      fieldName={allErrors?.sizeChart}
                                    />
                                  </div>
                                </div>
                                <div className="label-and-upload-box-shadow">
                                  <UploadedImages />
                                  <RenderImage file={fileupload} />
                                </div>
                              </div>
                              <div className="mcq-dv-all">
                                <h5>Select Inventory Type</h5>
                              </div>
                              <Select
                                isMulti={false}
                                options={inventoryTypes}
                                class="form-select mt-2 mb-2"
                                classNamePrefix="select Inventory Type"
                                onChange={(type) => {
                                  setSelectedInventoryType(type);
                                  setSelectedAttributes([]);
                                }}
                                value={selectedInventoryType}
                              />
                              <SelectedInventoryType />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="seller-save-btn">
                          <CustomButton
                            loading={loading}
                            onClickHandler={onSubmitHandler}
                            customClassName="custom-btn"
                          >
                            Create
                          </CustomButton>
                          <ResponseMessage />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Seller Adding Product ends here */}
      </AccessControl>
    </>
  );
}

export default EditProductContent;
